const CAROUSEL_CONTENT = [
  {
    paragraph: `I normally don't leave a review but - I was taking my water to a local store and kept getting different answers on what to do. These guys knew exactly how to treat water - my pool has never been as clean and controlled as it is today. I travel all the time, so it's nice to finally come home to a pool that is not hazy or smells like chlorine - what a difference.`,
    author: 'Mani, J.'
  },
  {
    paragraph: `What a great company with great owners. You can rely on Blue Sage Pools for superior service and exceptional value. Their experience in the pool industry definitely makes a difference.
You can trust Blue Sage Pools to take care of you.`,
    author: 'Bob, H.'
  },
  {
    paragraph: `I highly recommend Blue Sage Pools for any pool maintenance, pool repairs or outdoor living needs. The team at Blue Sage Pools are veterans in the Pool Industry. They are knowledgeable, trustworthy and provide outstanding service at a highly competitive price.`,
    author: 'Keith, R.'
  },
  {
    paragraph: `Blue Sage Pools is a company you can trust. Their owner is a man of integrity. They will do what they say they will do and get the job done when it's supposed to be done without compromising quality or craftsmanship.`,
    author: 'Patrick, C.'
  },
  {
    paragraph: `Blue Sage Pools has been incredible. They are reliable and efficient. They were very fair with their pricing. What I really love is how they take the time to explain all the issues to you. I highly recommend them!`,
    author: 'Jeff, C.'
  },
  {
    paragraph: `In this day and age, everyone is searching for the best value they can find in every area of their lives. For pool-related services and needs, you will find the best combination of price and service in the industry. You can't deliver great value unless you have extensive experience, high levels of service, and trustworthy performance. Try my friends at Blue Sage Pools - you will be thoroughly satisfied!`,
    author: 'Phil, S.'
  },
  {
    paragraph: `I have been very impressed with the folks at Blue Sage Pools. They were very professional and knowledgeable regarding my recent pool needs. A pleasure to do business with!`,
    author: 'Roger, S.'
  },
  {
    paragraph: `The owner is super nice, overly honest, and easy to want to do business with. He treats you like family and wants to exceed your expectations. I highly recommend this company because the owner understands service is #1.`,
    author: 'Chad, A.'
  },
  {
    paragraph: `Great attention to details, took amazing care to get our pool filter working and now clear water! Communication throughout the process was remarkable.`,
    author: 'Denise, H.'
  }
];

export { CAROUSEL_CONTENT };
